import { Modal, Button, Typography } from "antd";

const { Text, Paragraph, Title } = Typography;

interface Props {
  visible: boolean;
  loading: boolean;
  onAccept: () => void;
  onDeny: () => void;
}

const PrivacyPolicyModal = ({ visible, loading, onAccept, onDeny }: Props) => (
  <Modal
    open={visible}
    closable={false}
    maskClosable={false}
    centered
    zIndex={1000001}
    title={<Title level={4} style={{ margin: 0, color: "#fff" }}>Política de Privacidad</Title>}
    footer={[
      <Button key="deny" danger onClick={onDeny} disabled={loading}>
        Denegar
      </Button>,
      <Button key="accept" type="primary" loading={loading} onClick={onAccept}>
        Aceptar
      </Button>,
    ]}
  >
    <Paragraph>
      Al continuar, confirma que ha leído y acepta nuestra{" "}
      <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">
        Política de Privacidad
      </a>
      . Si hace clic en <Text strong>Denegar</Text>, su sesión será cerrada.
    </Paragraph>
  </Modal>
);

export default PrivacyPolicyModal;
